
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class SorunBildirAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "SorunBildirSave";
    super(baseUrl);
  }


  saveSorunBildirSave(sicilKodu: number, basvuruTuruId: number){
        let request = new SorunBildirSaveRequest(sicilKodu, basvuruTuruId);
    return this.post("", request, false);
   
  }

}
export default new SorunBildirAPI();

class SorunBildirSaveRequest {
    sicilKodu: number;
    basvuruTuruId: number;
    constructor(sicilKodu: number, basvuruTuruId: number) {
        this.sicilKodu = sicilKodu;
        this.basvuruTuruId = basvuruTuruId;
    }
    
}
export { SorunBildirSaveRequest };